import type { LucideIcon } from 'lucide-react'
import { Clock, Rocket, Shield } from 'lucide-react'

export type FinalCtaFormData = {
  name: string
  company: string
  email: string
  phone: string
  goal: string
  message: string
  website: string
}

export type FinalCtaGoalOption = {
  value: string
  label: string
}

export type FinalCtaBenefit = {
  icon: LucideIcon
  text: string
  sub: string
}

export const EMPTY_FINAL_CTA_FORM: FinalCtaFormData = {
  name: '',
  company: '',
  email: '',
  phone: '',
  goal: '',
  message: '',
  website: '',
}

export const FINAL_CTA_GOALS: FinalCtaGoalOption[] = [
  { value: 'website', label: 'Разработка сайта' },
  { value: 'app', label: 'Мобильное приложение' },
  { value: 'design', label: 'Дизайн и брендинг' },
  { value: 'marketing', label: 'Digital-маркетинг' },
  { value: 'support', label: 'Техподдержка' },
  { value: 'other', label: 'Другое' },
]

export const FINAL_CTA_BENEFITS: FinalCtaBenefit[] = [
  { icon: Rocket, text: 'Без скрытых условий', sub: 'Первая консультация полностью бесплатна' },
  { icon: Clock, text: 'Ответ за 2 часа', sub: 'Ценим ваше время так же, как своё' },
  { icon: Shield, text: 'NDA по запросу', sub: 'Ваш проект — ваша тайна' },
]
